import { useEffect, useState } from "react";

const Typewriter = ({ text, speed = 100, pause = 1500 }) => {
  const [displayed, setDisplayed] = useState("");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let typingTimeout;

    if (index < text.length) {
      typingTimeout = setTimeout(() => {
        setDisplayed((prev) => prev + text.charAt(index));
        setIndex((prev) => prev + 1);
      }, speed);
    } else {
      typingTimeout = setTimeout(() => {
        setDisplayed("");
        setIndex(0);
      }, pause);
    }

    return () => clearTimeout(typingTimeout);
  }, [index, text, speed, pause]);

  return (
    <>
      {displayed}
    </>
  );
};

export default Typewriter;
